// FetchVPCDetails.js

import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import './FetchVPCDetails.css';
// import MainModal from './MainModal';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Modal from 'react-bootstrap/Modal';
// import BTModal from './BTModal';
import { getCurrentUser } from 'aws-amplify/auth';
import vpcCidrList from './vpcCIDRList'; // Import VPCCIDRList.js

function FetchVPCDetails(username) {
  const [textInput, setTextInput] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [data, setData] = useState([]);
  const [parsedData, setParsedData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const [requestComplete, setRequestComplete] = useState(false);
  const [responseText, setResponseText] = useState('');
  const [error, setError] = useState('');
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [overlapMessage, setOverlapMessage] = useState('');
  const handleConnect = () => {
    setButtonDisabled(true);
    // Perform post request with VPC ID
    console.log("POST  DATA is",data)
    fetch('https://qwj7xbfkm8.execute-api.us-west-2.amazonaws.com/Arti-prod-deployment/artifactory', {
      method: 'POST',
      body: JSON.stringify({ "vpcid": parsedData.vpcid, "username": username }), // Assuming data.body contains VPC ID
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Error connecting');
      }
      return response.json();
    })
    .then(data => {
      setResponseText(data); // Assuming the response contains a message field
      setError('');
	
    setRequestComplete(true);
    })
    .catch(error => {
      console.error('Error connecting:', error);
      setResponseText('');
      setError('Error connecting. Please try again.');
    });
  };

  const handleCloseModal = () => {
    setButtonDisabled(false);
    setShowModal(false);
    setRequestComplete(false);
    setOverlapMessage('');
    };

  const handleFetchData = async () => {

    console.log("line14")
    setLoading(true);
    const { username, userId, signInDetails } = await getCurrentUser();
    console.log(`The username: ${username}`);
    console.log(`The userId: ${userId}`);
    console.log(`The signInDetails: ${signInDetails}`);
    // fetch(`https://3ibcnm3qp4.execute-api.us-west-2.amazonaws.com/Preprod/Artifactory?vpcid=${textInput}`)
    await fetch(`https://qwj7xbfkm8.execute-api.us-west-2.amazonaws.com/Arti-prod-deployment/artifactory?vpcid=${textInput}`)
      .then(response => response.json())
      .then(data => {
        setData(data);
        console.log(data)
          
        setShowModal(true); // Show modal if data is returned
        const parsedData = JSON.parse(data.body);
        setParsedData(parsedData)
        checkOverlap({ vpcCidrs: parsedData.vpc_cidr, LockValue: parsedData.LockValue });

        // checkOverlap(parsedData.vpc_cidr);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
        setErrorMessage('Error fetching data. Please try again.');
      });

      setLoading(false); 

  };

  const checkOverlap = ({vpcCidrs, LockValue}) => {
    let overlappingSubnets = [];

    for (const cidr of vpcCidrs) {
      if (vpcCidrList.includes(cidr)) {
        overlappingSubnets.push(cidr);
      }
    }

    if (overlappingSubnets.length > 0) {
      const message = `Overlapping subnets: ${overlappingSubnets.join(', ')}`;
      setOverlapMessage(message);
      setButtonDisabled(true);
    }  else if(LockValue=="True"){
      console.log("Lock value",LockValue);
      const message="Another VPC connectivity request is in progress - please try after 3 mins";
      setOverlapMessage(message);
          setButtonDisabled(true);		
    } else {
      setButtonDisabled(false);
    }
  };


  return (
    <div className={`container ${showModal ? 'modal-open' : ''}`}>
      <h2>Fetch VPC Details</h2>
      <div className="input-group">
      <Form>
      <Form.Group
              className="mb-3"
            >
      <Form.Control
        type="text"
        id="vpcinput"
        value={textInput}
          onChange={(e) => setTextInput(e.target.value)}
          placeholder="Enter VPC ID"
          readOnly={showModal} // Make the input read-only when the modal is shown
      />
       </Form.Group>
           <Button onClick={handleFetchData} disabled={isLoading} > Submit</Button>
           
      </Form>
   
      </div>
      <div className="error-message">{errorMessage}</div>
      {/* {showModal && <Modal data={data} closeModal={closeModal} />} */}
      {showModal &&
        <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={showModal}
    >
      <Modal.Header >
        <Modal.Title id="contained-modal-title-vcenter">
          VPC details for {textInput}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <table style={{ width: '100%' }}>
          <tbody>
            <tr>
              <td>Account ID</td>
              <td>{parsedData.account_id}</td>
            </tr>
            <tr>
              <td>Account Environment</td>
              <td>{parsedData.account_environment}</td>
            </tr>
            <tr>
              <td>Region</td>
              <td>{parsedData.region}</td>
            </tr>
            <tr>
              <td>VPC ID</td>
              <td>{parsedData.vpcid}</td>
            </tr>
            <tr>
            <td>VPC CIDR</td>
            <td>{parsedData.vpc_cidr ? parsedData.vpc_cidr.join(', ') : ''}</td>
            </tr>

            <tr>
            <td>Artifactory Status</td>
            <td>{parsedData.ArtifactoryStatus}</td>
            </tr>

          </tbody>
        </table>
      </Modal.Body>
      {overlapMessage && (
    <Row className="justify-content-end" >
      <Col xs={9}>
        <Form.Control plaintext readOnly defaultValue={overlapMessage} style={{ color: 'red' }} />
      </Col>
    </Row>
  )}
<Modal.Footer>

  {!requestComplete && (
    <Row className="justify-content-end">
      <Col xs="auto">
        <Button variant={overlapMessage ? "primary" : "outline-primary"} onClick={handleCloseModal}>Cancel</Button>
      </Col>
      {!buttonDisabled && (
        <Col xs="auto">
          <Button onClick={handleConnect}>Connect to Artifactory</Button>
        </Col>
      )}
    </Row>
  )}
  {requestComplete && (
    <Row className="justify-content-end">
      <Col xs={9}>{responseText}</Col>
      <Col xs="auto">
        <Button variant="outline-primary" onClick={handleCloseModal}>Close</Button>
      </Col>
    </Row>
  )}
  

</Modal.Footer>
    </Modal>
        
        
        
        
         }
    </div>
  );
}

export default FetchVPCDetails;
